var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import { css } from 'styled-components';
export var iconBaseStyles = function (_a) {
    var _b = _a.mousePointer, mousePointer = _b === void 0 ? false : _b;
    return css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: inline-block;\n  vertical-align: baseline;\n  ", "\n"], ["\n  display: inline-block;\n  vertical-align: baseline;\n  ",
        "\n"])), !!mousePointer &&
        "cursor: pointer;\n      & * {\n        cursor: inherit;\n      }\n  ");
};
var templateObject_1;
//# sourceMappingURL=Icon.baseStyles.js.map